module.exports = __webpack_public_path__ + "img/rights-banner_btn.0103e0af.png";